module.exports = __webpack_public_path__ + "static/img/rl.f43518b6.png";